import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useLanguageStore } from "@/stores/languageStore";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export const CookieConsent = () => {
  const { t } = useLanguageStore();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-in-bottom pointer-events-none">
      <div className="container max-w-4xl pointer-events-auto">
        <div className="relative bg-card border border-border rounded-2xl p-6 shadow-2xl">
          <button 
            onClick={handleDecline}
            className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
          
          <div className="flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
            <div className="flex-1 pe-8">
              <h3 className="font-display text-lg font-semibold mb-2">{t("cookies.title")}</h3>
              <p className="text-muted-foreground text-sm">
                {t("cookies.description")}{" "}
                <Link to="/privacy" className="text-foreground font-medium underline hover:text-primary">
                  {t("cookies.learnMore")}
                </Link>
              </p>
            </div>
            
            <div className="flex gap-3 flex-shrink-0">
              <Button variant="outline" onClick={handleDecline}>
                {t("cookies.decline")}
              </Button>
              <Button onClick={handleAccept} className="bg-foreground text-background hover:bg-foreground/90">
                {t("cookies.accept")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
